import React from 'react';
import { Container, Navbar } from 'react-bootstrap';

import linkedinIcon from '@/assets/img/icons/svg/linkedinIcon.svg';
import facebookIcon from '@/assets/img/icons/svg/facebookIcon.svg';
import xIcon from '@/assets/img/icons/svg/xIcon.svg';
import githubIcon from '@/assets/img/icons/svg/githubIcon.svg';
import instagramIcon from '@/assets/img/icons/svg/instagramIcon.svg';

import './Footer.css';

export default function Footer() {
    return (
        <div id="footer" className="bg-light px-3 px-md-auto">
            <div className="footer-container">
                <Navbar expand="sm" className="footer-navbar">
                    <Container fluid className="bg-light">
                        <Navbar.Brand>
                            <a
                                href="/"
                                className="h2 text-decoration-none mt-2 footer-title"
                            >
                                Sustainability Hub
                            </a>
                            <div className="footer-right-navbar-socials mobile-socials">
                                <a
                                    id="linkedin"
                                    href="https://www.linkedin.com/company/co-sustainability-hub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={linkedinIcon}
                                        alt="linkedin logo"
                                    />
                                </a>
                                <a
                                    id="facebook"
                                    href="https://www.facebook.com/cosustainhub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={facebookIcon}
                                        alt="facebook logo"
                                    />
                                </a>
                                <a
                                    id="x"
                                    href="https://twitter.com/co_sustain_hub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={xIcon} alt="X logo" />
                                </a>
                                <a
                                    id="github"
                                    href="https://github.com/msu-denver/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={githubIcon} alt="github logo" />
                                </a>
                                <a
                                    id="instagram"
                                    href="https://www.instagram.com/co_sustain_hub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={instagramIcon}
                                        alt="instagram logo"
                                    />
                                </a>
                            </div>
                            <div className="footer-policies">
                                <a
                                    href="/policies"
                                    className="h6 policy text-capitalize"
                                >
                                    View our Policies
                                </a>
                                <span className="mx-2">|</span>
                                <a
                                    href="/takedown"
                                    className="h6 policy text-capitalize"
                                >
                                    Content Takedown
                                </a>
                                <span className="mx-2">|</span>
                                <a
                                    href="/feedback"
                                    className="h6 policy text-capitalize"
                                >
                                    Send Feedback
                                </a>
                                <span className="mx-2">|</span>
                                <a
                                    href="/contact"
                                    className="h6 policy text-capitalize"
                                >
                                    Contact Us
                                </a>
                            </div>
                            <div className="footer-copyright ">
                                <p className="h6 copyright">
                                    &copy; {new Date().getFullYear()}{' '}
                                    Metropolitan State University of Denver
                                </p>
                            </div>
                        </Navbar.Brand>
                        <div className="footer-right-navbar">
                            <p className="h2 text-decoration-none text-uppercase footer-right-navbar-top">
                                Connect with us:
                            </p>
                            <div className="footer-right-navbar-socials">
                                <a
                                    id="linkedin"
                                    href="https://www.linkedin.com/company/co-sustainability-hub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={linkedinIcon}
                                        alt="linkedin logo"
                                    />
                                </a>
                                <a
                                    id="facebook"
                                    href="https://www.facebook.com/cosustainhub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={facebookIcon}
                                        alt="facebook logo"
                                    />
                                </a>
                                <a
                                    id="x"
                                    href="https://twitter.com/co_sustain_hub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={xIcon} alt="X logo" />
                                </a>
                                <a
                                    id="github"
                                    href="https://github.com/msu-denver/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={githubIcon} alt="github logo" />
                                </a>
                                <a
                                    id="instagram"
                                    href="https://www.instagram.com/co_sustain_hub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={instagramIcon}
                                        alt="instagram logo"
                                    />
                                </a>
                            </div>
                        </div>
                    </Container>
                </Navbar>
            </div>
        </div>
    );
}
